import { useAtomValue, useSetAtom } from "jotai";
import { useRouter } from "next/router";
import { useCallback, useEffect } from "react";

import { $canGoBack, $canGoForward, $trackNavigation } from "../../internal/navigation-history";

export const useNavigationHistory = () => {
	const canGoBack = useAtomValue($canGoBack);
	const canGoForward = useAtomValue($canGoForward);
	const router = useRouter();

	const goBack = useCallback(() => {
		if (canGoBack) {
			router.back();
		}
	}, [canGoBack, router]);

	const goForward = useCallback(() => {
		if (canGoForward && typeof window !== "undefined") {
			window.history.forward();
		}
	}, [canGoForward]);

	return {
		canGoBack,
		canGoForward,
		goBack,
		goForward,
	};
};

export const useNavigationHistoryTracker = () => {
	const router = useRouter();
	const trackNavigation = useSetAtom($trackNavigation);

	useEffect(() => {
		const handleRouteChange = () => {
			const key =
				typeof window !== "undefined"
					? (window.history.state?.key as string | undefined)
					: undefined;

			if (key) {
				trackNavigation(key);
			}
		};

		handleRouteChange();

		router.events.on("routeChangeComplete", handleRouteChange);

		return () => {
			router.events.off("routeChangeComplete", handleRouteChange);
		};
	}, [router.events, trackNavigation]);
};
